import PropTypes from "prop-types";

import styled from "styled-components/macro";

import { FNC_UPGRADE } from "Flocknote/GlobalComponents/Modal/contentKeys";
import flocknoteStateHooks from "Flocknote/stateHooks";

import { useGetSideLinks } from "Dashboard/DashboardCards/API/queries";
import unoPiggyBank from "Payments/FundItPage/images/uno-piggy-bank.png";
import { motion } from "framer-motion";

const SideLink = ({ onClick, icon, iconColor, text }) => (
  <Wrapper initial={{ height: 70 }} animate={{ height: 70 }}>
    <Main onClick={onClick}>
      <Left>
        <Icon $iconColor={iconColor}>
          {icon === "piggybank" ? (
            <PiggyBankImage />
          ) : (
            <span className={icon} />
          )}
        </Icon>
        <Text>{text}</Text>
      </Left>
    </Main>
  </Wrapper>
);

export default function SideLinks() {
  const {
    data: { shouldShowOnlineGiving = false, shouldShowFNC = false } = {},
  } = useGetSideLinks();
  const [, { openModal }] = flocknoteStateHooks.useModal();

  return (
    <LinksContainer>
      {shouldShowOnlineGiving && (
        <SideLink
          onClick={() => window.fnReactBus.goToUrl("/onlineGivingEnrollment")}
          icon="piggybank"
          iconColor="#d1d7b6"
          text="Learn about Online Giving"
        />
      )}
      {shouldShowFNC && (
        <SideLink
          onClick={() => openModal(FNC_UPGRADE)}
          icon="fa-users fas"
          iconColor="#a5c8e4"
          text="Upgrade your plan to Flocknote Complete"
        />
      )}
    </LinksContainer>
  );
}

SideLink.propTypes = {
  onClick: PropTypes.func,
  icon: PropTypes.string,
  iconColor: PropTypes.string,
  text: PropTypes.string,
};
const LinksContainer = styled.div`
  background-color: white;
  border-radius: 12px;
  margin-bottom: 20px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.08);
`;

const Wrapper = styled(motion.div)`
  background-color: white;
  border-radius: 12px;
  padding: 2px;
  overflow: hidden;
`;

const Main = styled.div`
  padding: 13px 10px 13px 9px;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  border-radius: 10px;
  transition: background 200ms;

  &:hover {
    background: rgba(0, 0, 0, 0.05);
  }
`;

const Left = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`;

const Icon = styled.div`
  margin-right: 12px;
  font-size: 21px;
  color: white;
  background-color: ${({ $iconColor }) => $iconColor};
  border-radius: 100%;
  height: 44px;
  width: 44px;
  flex-shrink: 0;
  flex-grow: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Text = styled.div`
  color: #2f3f4f;
  font-weight: 500;
`;

const PiggyBankImage = styled.div`
  background-image: url(${unoPiggyBank});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center center;
  opacity: 0.8;
  width: 25px;
  height: 25px;
  flex-shrink: 0;
`;
